<template>
    <div class="main-container">
        <div class="center-top-title">
            <h4>{{goodsName}}</h4>
        </div>

        <div style="font-size: 13px;">
            <div class="goods-item">
                <span>支付价格</span>
                <div>
                    <span v-if="showDiscount && radio !== '8'" style="color: #9e9e9e;text-decoration: line-through;margin-right: 5px;">
                        {{ payOriginalPrice }}
                    </span>
                    <span v-if="radio === '8'" style="font-weight: bold;color:#54578C;">{{payOriginalPrice}}</span>
                    <span v-else style="font-weight: bold;color:#54578C;">{{orderMoney}}</span>
                </div>

            </div>
            <div class="goods-item">
                <span>优惠金额 / 折扣</span>
                <span v-if="radio === '8'">无优惠</span>
                <span v-else>{{payDiscount}}</span>
            </div>
            <div v-if="showLimitedTimeDiscount" style="font-size: 12px;text-align: left;color: #ee9f2a;padding: 0 15px;">
                限时福利：开服当日2.2折，截止到24:00
            </div>
        </div>

        <div style="font-size: 12px;color: #888888;text-align: left;padding: 0 15px;margin: 8px 0 8px;">
            请选择支付方式
        </div>
        <div class="pay-class">
            <van-radio-group v-model="radio">
                <div @click="radio = '2'" style="display: flex;align-items: center;justify-content: space-between;background-color:#f5f5f5;padding: 5px 8px;margin-bottom: 1px;cursor: pointer;">
                    <div style="display: flex;">
                        <img :src="zfbPayIcon" style="width: 18px;height: 18px;">
                        <span style="font-size: 12px;margin-left: 10px;">支付宝</span>
                    </div>
                    <van-radio name="2" shape="square" icon-size="13px" checked-color="#54578C"/>
                </div>

                <div @click="radio = '3'" style="display: flex;align-items: center;justify-content: space-between;background-color:#f5f5f5;padding: 5px 8px;margin-bottom: 1px;cursor: pointer;">
                    <div style="display: flex;">
                        <img :src="wxPayIcon" style="width: 18px;height: 18px;">
                        <span style="font-size: 12px;margin-left: 10px;">微信</span>
                    </div>
                    <van-radio name="3" shape="square" icon-size="13px" checked-color="#54578C"/>
                </div>

                <div @click="radio = '1'" style="display: flex;align-items: center;justify-content: space-between;background-color:#f5f5f5;padding: 5px 8px;margin-bottom: 1px;cursor: pointer;">
                    <div style="display: flex;">
                        <img :src="logoUrl" style="width: 18px;height: 18px;">
                        <span style="font-size: 12px;margin-left: 10px;">{{ webConfig.coinName }}
                            <span style="color: #888888">余额: {{jhb}}</span>
                        </span>
                    </div>
                    <van-radio name="1" shape="square" icon-size="13px" checked-color="#54578C"/>
                </div>

                <div @click="radio = '8'" style="display: flex;align-items: center;justify-content: space-between;background-color:#f5f5f5;padding: 5px 8px;margin-bottom: 5px;cursor: pointer;">
                    <div style="display: flex;">
                        <img :src="logoUrl" style="width: 18px;height: 18px;">
                        <span style="font-size: 12px;margin-left: 10px;">{{webConfig.bindCoinName}}
                            <span style="color: #888888">余额: {{bindb}}</span>
                        </span>
                    </div>
                    <van-radio name="8" shape="square" icon-size="13px" checked-color="#54578C"/>
                </div>

            </van-radio-group>
        </div>

        <div class="box-button">
            <van-button type="info" @click="submitPay" block native-type="submit" size="small" round style="width: 160px;"
                        :loading="loading" loading-text="正在支付"
                        color="#54578C">
                确认支付
            </van-button>
            <p class="text-button" @click="back">取消支付
            </p>
        </div>
    </div>
</template>

<script>

    import {preOrder, getBalance, checkUser} from '@/api/request'
    //import crypto from '@/utils/crypto.js';
    import wxPayIcon from "@/assets/pay_wx.png";
    import zfbPayIcon from "@/assets/pay_zfb.png";
    import {Toast} from 'vant'
    import webConfig from "@/api/config";

    export default {
        name: 'pay',
        data: function () {
            return {
                wxPayIcon,
                zfbPayIcon,
                jhb: '0',
                bindb: '0',
                goodsName: '',
                money: '',
                orderMoney: '',
                uid: '-',
                radio: '',
                loading: false,
                channelId: '',
                gameId: '',
                order: {},
                showDiscount: false,
                preferenceMoney: '',
                payDiscount: '无优惠',
                payOriginalPrice: '',
                from: '',
                webConfig: {},
                logoUrl: '',
                showLimitedTimeDiscount: false,
            }
        },
        mounted() {
            let user = JSON.parse(localStorage.getItem('user'));
            this.uid = user.userId;
            this.channelId = localStorage.getItem("channelId");
            this.gameId = localStorage.getItem("gameId");
            this.from = localStorage.getItem("from");
            this.webConfig = webConfig;
            this.logoUrl = webConfig.logoUrl;
        },
        methods: {
            initOrder(order) {
                console.log('initOrder...')
                this.goodsName = order.goodsName;
                this.orderMoney = "￥" + (order.money / 100).toFixed(2);
                this.payOriginalPrice = "￥" + (order.money / 100).toFixed(2);
                this.money = order.money;
                this.order = order;

                let params = {
                    channelId: this.channelId,
                    sdkVersion: "1.0.0",
                    gameId: this.order.gameId,
                    cpOrder: this.order.cpOrderId,
                    goodsName: this.goodsName,
                    money: this.money,
                    paymentType: this.handPayType(this.radio),
                    serviceId: this.order.serverId,
                    desc: this.goodsName,
                    roleName: this.order.roleName,
                };
                checkUser(params).then(res => {
                    if (res.data.success) {
                        if (res.data.data.discount !== "1") {
                            this.showDiscount = true;
                            this.preferenceMoney = "￥" + res.data.data.preferenceMoney + ' / ' + res.data.data.discount;
                        } else {
                            this.showDiscount = false;
                        }
                        this.payDiscount = "￥" + res.data.data.preferenceMoney + ' / ' + res.data.data.discount ;
                        this.orderMoney = "￥" + res.data.data.orderMoney;

                        let leaveTime = res.data.data.leaveTime;
                        if (leaveTime && leaveTime !== '0') {
                            this.showLimitedTimeDiscount = true;
                        }

                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            back() {
                this.$parent.$parent.closePayPage();
            },
            getBalance() {
                let params = {
                    channelId: this.channelId,
                    gameId: this.gameId,
                };
                getBalance(params).then(res => {
                    if (res.data.success) {
                        this.jhb = res.data.data.balance;
                        this.bindb = res.data.data.bindBalance;
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            submitPay() {
                if (!this.radio) {
                    Toast('请选择支付方式');
                    return;
                }
                this.loading = true;
                let payType = this.handPayType(this.radio);
                let params = {
                    channelId: this.channelId,
                    sdkVersion: "1.0.0",
                    gameId: this.order.gameId,
                    cpOrder: this.order.cpOrderId,
                    goodsName: this.goodsName,
                    money: this.money,
                    paymentType: payType,
                    serverId: this.order.serverId,
                    desc: this.goodsName,
                    roleName: this.order.roleName,
                    roleId: this.order.roleId,
                    time: this.order.time,
                    sign: this.order.sign
                };
                preOrder(params).then(res => {
                    this.loading = false;
                    if (res.data.success) {
                        if (res.data.data.paymentType !== "1" && res.data.data.paymentType !== "8") {
                            let payUrl = res.data.data.payString;
                            let orderId = res.data.data.orderId;

                            if (this.from.includes('android') && payType !== '5') {
                                window.androidJs.openUrl(payUrl);
                                setTimeout(() => {
                                    window.androidJs.openUrl('https://notexistpage404.com');
                                }, 10000);
                            }
                            else {
                                this.$parent.$parent.openPayUrl(payUrl, res.data.data.paymentType, this.orderMoney, this.payOriginalPrice, orderId);
                            }
                        }
                        else {
                            Toast('支付成功');
                        }
                        this.back();
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            handPayType(payType) {
                if (payType === '1' || payType === '8') {
                    return payType
                }
                //H5支付没下来 强制扫码支付
                if (payType === '3') {//微信
                    return '5' //微信扫码
                }

                let isMobile = this.isMobile();
                if (isMobile) {
                    return payType;
                }
                if (payType === '2') {//支付宝
                    return '4' //支付宝扫码
                }
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return flag;
            },
        }
    }
</script>

<style scoped>
    .main-container {
        padding: 10px 15px;
        box-sizing: border-box;
    }
    .goods-item {
        height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        padding: 0 15px;
    }

    .center-top-title {
        vertical-align: center;
        height: 2rem;
        line-height: 2rem;
    }

    .center-top-title h4 {
        display: inline-block;
        font-size: 20px;
        margin: 0;
        color: #5e5e5e;
    }

    .top-label span {
        margin-left: .5rem;
    }

    .pay-class {
        text-align: left;
        padding: 0 16px;
        color: #5e5e5e;
        user-select: none;
    }

    .box-button {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin: 12px 0 0;
    }

    p {
        margin: 0;
    }

    .text-button {
        font-size: .8rem;
        margin-top: 8px;
        color: #888888;
        cursor: pointer;
    }

</style>
